import { render } from "./NeobuqReportTable.vue?vue&type=template&id=1fb035ec&scoped=true"
import script from "./NeobuqReportTable.vue?vue&type=script&lang=js"
export * from "./NeobuqReportTable.vue?vue&type=script&lang=js"

import "./NeobuqReportTable.vue?vue&type=style&index=0&id=1fb035ec&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb035ec"]])

export default __exports__